// extracted by mini-css-extract-plugin
export var cardTitle = "_ip-1";
export var commentBubble = "_ip-e";
export var commentForm = "_ip-a";
export var commentInput = "_ip-b";
export var commentLabel = "_ip-d";
export var commentPrompt = "_ip-9";
export var csatCard = "_ip-0";
export var feedbackSection = "_ip-7";
export var starDisabled = "_ip-6";
export var starEmpty = "_ip-5";
export var starFilled = "_ip-4";
export var starWrapper = "_ip-3";
export var starsContainer = "_ip-2";
export var submittedComment = "_ip-c";
export var thankYouText = "_ip-8";